<template>
  <img
    v-if="!defaultImage || !onImageError"
    :class="imageClass"
    :src="imageSrc"
    :style="imageStyle"
    :alt="imageAlt"
    :title="imageTitle"
    @error="onImageLoadError"
  />
  <img
    v-else-if="
      $configuration.placeholderImage && !onCustomDefaultImageError && useCustomDefaultImage
    "
    :class="imageClass"
    :src="customDefaultImageSrc"
    :style="imageStyle"
    :alt="imageAlt"
    :title="imageTitle"
    @error="onCustomDefaultImageLoadError"
  />
  <font-awesome-icon
    v-else
    :class="['text-muted', defaultClass]"
    :icon="defaultIcon"
    :title="defaultTitle"
  />
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  emits: ['imgLoadError', 'onCustomDefaultImageError'],
  props: {
    imageSrc: {
      type: String,
      required: true,
    },
    imageAlt: {
      type: String,
      required: true,
    },
    imageClass: {
      type: String,
    },
    imageTitle: {
      type: String,
    },
    imageStyle: {
      type: String,
    },
    defaultClass: {
      type: String,
    },
    defaultImage: {
      type: Boolean,
      default: true,
    },
    defaultIcon: {
      type: String,
      default: 'camera',
    },
    defaultTitle: {
      type: String,
    },
    useCustomDefaultImage: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      onImageError: false,
      onCustomDefaultImageError: false,
    };
  },
  watch: {
    imageSrc() {
      this.onImageError = false;
      this.onCustomDefaultImageError = false;
    },
  },
  methods: {
    onImageLoadError() {
      this.$emit('imgLoadError');
      this.onImageError = true;
    },
    onCustomDefaultImageLoadError() {
      this.$emit('onCustomDefaultImageError');
      this.onCustomDefaultImageError = true;
    },
  },
  computed: {
    src() {
      return `${this.$configuration.cdn}/api/img/${this.format}/${this.data}`;
    },
    customDefaultImageSrc() {
      return `${this.$configuration.cdn}/api/img/${this.$configuration.placeholderImage}`;
    },
  },
});
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.barcode {
  display: block;
  max-width: rem(350px);
  margin: 0 auto;
}
</style>
